"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _newArrowCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/newArrowCheck"));

var _react = _interopRequireDefault(require("react"));

var _this = void 0;

var _default = /*#__PURE__*/_react.default.memo(function () {
  (0, _newArrowCheck2.default)(this, _this);
  return /*#__PURE__*/_react.default.createElement("path", {
    d: "M12,3 C12.5522847,3 13,3.44771525 13,4 L13,20 C13,20.5522847 12.5522847,21 12,21 C11.4477153,21 11,20.5522847 11,20 L11,4 C11,3.44771525 11.4477153,3 12,3 Z",
    transform: "rotate(90 12 12)"
  });
}.bind(void 0));

exports.default = _default;